import { Icon } from '@talkdesk/cobalt-react-icon'
import { useTheme } from '@talkdesk/cobalt-react-theme-provider'
import { SECURITY_KEY_ANIMATION } from '../../../constants/images'
import '../../../../assets/css/web-authn-animation.css'

const WebAuthnLoginAnimation = ({ talkdeskIdAssetsURL, isValid = false }) => {
  const theme = useTheme()

  return (
    <div className={`svg-animation ${isValid ? 'ok' : ''}`}>
      <div className="co--push-right">
        {/* using an object to force rendering the svg animation, which doesn't reset when re-rendered */}
        <object
          type="image/svg+xml"
          data={SECURITY_KEY_ANIMATION(talkdeskIdAssetsURL)}
          aria-label="webAuthn login"
        />
      </div>
      <div className="svg-success co--push-center">
        <Icon name="check" size="xlarge" color={theme.green600} />
      </div>
    </div>
  )
}

export default WebAuthnLoginAnimation
